import { Switch, Route, Redirect } from 'react-router-dom';

import HomePage from './containers/HomePage';
import FromHkustPage from './containers/FromHkustPage';
import ToHkustPage from './containers/ToHkustPage';
import ShuttlePage from './containers/ShuttlePage';
import BasicLayout from './layouts/BasicLayout';

const routes = [
	{ path: '/', exact: true, Component: HomePage },

	{ path: '/from-hkust/:tab/:slug', exact: true, Component: FromHkustPage },
	{ path: '/from-hkust/:tab', exact: true, Component: FromHkustPage },
	{ path: '/from-hkust', exact: true, redirect: '/from-hkust/bus-stops/north-gate' },

	{ path: '/to-hkust/locations/:slug', exact: true, Component: ToHkustPage },
	{ path: '/to-hkust/locations', exact: true, Component: ToHkustPage },
	{ path: '/to-hkust', exact: true, redirect: '/to-hkust/locations' },

	{ path: '/shuttle-bus/:tab', exact: true, Component: ShuttlePage },
	{ path: '/shuttle-bus', exact: true, redirect: '/shuttle-bus/students-and-staff' }
];

const Routes = ({ location }) => {
	return (
		<Switch location={location}>
			{routes.map(({ path, exact, Component, redirect }, index) => (
				<Route
					key={index}
					path={path}
					exact={exact}
					render={(props) => {
						if (redirect) {
							return <Redirect to={redirect} />;
						}
						return (
							<BasicLayout location={location}>
								<Component {...props} />
							</BasicLayout>
						);
					}}
				/>
			))}
			<Route render={() => <Redirect to={'/'} />} />
		</Switch>
	);
};

export default Routes;
